export default "__VITE_ASSET__1f4059d5__"